'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {logger} from '../logger';
import {getDomainInstance} from '../../../core-utilities/domain/ReduxUtils';
import {Button} from '../../../components/buttons/Button';
import {getPermissions, TaskScheduleDialogController} from '../../controllers/TaskScheduleDialogController';
import taskScheduleModalTemplate from '../../controllers/task-schedule-modal.html';
import {ScheduleModalMode} from '../../enums/ScheduleModalMode';


export class TaskAssignmentButtonComponent extends Component {
  static propTypes = {
    className: T.string,
    children: T.node,
    model: T.object,
    allowNav: T.bool,
  };

  static $inject = [
    '$modal',
    '$permissions',
    '$translate',
    'TaskStatusService',
    'TaskDomain',
    'PersonnelService',
    'userPresenceService',
  ];

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * @param {MouseEvent} e
   * @private
   */
  handleClick(e) {
    e.stopPropagation();
    TaskAssignmentButtonComponent.openAssignmentDialog(this.props.model, this.props.permissions, this.props.allowNav)
      .catch(err => {
        if (err && err.message) {
          logger.error({err}, `Assignment Dialog failed with error="${err.message}"`);
        }
      });
  }

  render() {
    return (
      <Button
        className={this.props.className}
        onClick={this.handleClick}
      >
        {this.props.children}
      </Button>
    );
  }

  /**
   * @param {Object} task
   * @param {Object<String, Boolean>} permissions
   * @param {Boolean} allowNav
   */
  static openAssignmentDialog(task, permissions, allowNav) {
    const $modal = TaskAssignmentButtonComponent.dependencies.$modal;
    const $permissions = TaskAssignmentButtonComponent.dependencies.$permissions;
    const mode = allowNav ? ScheduleModalMode.foreign : ScheduleModalMode.local;

    return Promise.all([
      permissions ? Promise.resolve(permissions) : getPermissions($permissions, task),
      getDomainInstance(task),
    ]).then(data =>
      $modal.show({
        template: taskScheduleModalTemplate,
        controller: TaskScheduleDialogController,
        locals: {
          mode,
          permissions: data[0],
          task: data[1],
        },
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskAssignmentButton/TaskAssignmentButtonComponent.js